import e from "./ghl-ui.es1506.js";
import o from "./ghl-ui.es1466.js";
function s(t) {
  o(1, arguments);
  var r = e(t);
  return r.setMinutes(0, 0, 0), r;
}
export {
  s as default
};
